import { create, ZoidComponent } from 'zoid/dist/zoid.frameworks'
import { commonComponentsProps } from '../common/props'
import { handleOpenChargebeeCheckout } from '../common/useChargebee'

import defaultLoader from '../common/defaultLoaderTemplate'
import simpleContainerTemplate from './template'

const cdc: ZoidComponent = create({
  tag: 'mbo-cdc-modules',

  url: ({ props }) => props.url,

  context: 'iframe',

  dimensions: {
    width: '100%',
  },

  containerTemplate: simpleContainerTemplate,

  prerenderTemplate: defaultLoader,

  props: {
    ...commonComponentsProps,

    handleOpenChargebeeCheckout,

    url: {
      type: 'string',
      required: true,
    },

    handleOpenModal: {
      type: 'function',
      required: true,
    },
  },
})

export default cdc
